import { type FC, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useBlocNext } from "@blac/react";
import LeapChatCubit from "./LeapChatCubit";
import ChatComposer from "./ChatComposer";
import {
  LeapChatContentPositioner,
  HeroContainer,
  HeroHeading
} from "./leapChat.styles";
import UserPreferencesCubit from "src/state/UserPreferencesCubit/UserPreferencesCubit";

const NewConversationView: FC = () => {
  const [{ inputValue, isRunning }, cubit] = useBlocNext(LeapChatCubit);
  const [{ "auth.user.firstname": firstName, "auth.user.nickname": nickName }] =
    useBlocNext(UserPreferencesCubit);
  const navigate = useNavigate();

  useEffect(() => {
    cubit.clearActiveConversation();
  }, [cubit]);

  const handleSend = useCallback(async () => {
    const text = inputValue.trim();
    if (!text || isRunning) {
      return;
    }
    cubit.setInputValue("");
    const newId = await cubit.startNewConversation(text);
    if (newId) {
      navigate(`/app/chat/conversation/${newId}`, { replace: true });
    }
  }, [inputValue, isRunning, cubit, navigate]);

  return (
    <LeapChatContentPositioner>
      <HeroContainer>
        <HeroHeading>
          Hi {nickName ?? firstName}, how can we help you today?
        </HeroHeading>
        <ChatComposer
          onSend={() => void handleSend()}
          placeholder="Ask about your health, medications, or results…"
          autoFocus
        />
      </HeroContainer>
    </LeapChatContentPositioner>
  );
};

export default NewConversationView;
